import { useEffect, useState } from 'react'

const NOTES = ['🎵', '🎶', '♪', '♫', '🎵', '🎶', '♪']
const COLORS = ['var(--purple)', '#E879F9', '#818CF8', '#F472B6', '#A78BFA', '#38BDF8']
const NOTE_COUNT = 18
const DURATION = 2800

function randomBetween(a, b) {
  return a + Math.random() * (b - a)
}

export default function MusicNoteAnimation({ onDone }) {
  const [notes] = useState(() =>
    Array.from({ length: NOTE_COUNT }, (_, i) => ({
      id: i,
      note: NOTES[i % NOTES.length],
      left: randomBetween(5, 95),
      size: randomBetween(16, 32),
      delay: randomBetween(0, 800),
      drift: randomBetween(-40, 40),
      duration: randomBetween(1800, 2600),
      color: COLORS[i % COLORS.length],
    }))
  )

  useEffect(() => {
    const timer = setTimeout(() => onDone?.(), DURATION)
    return () => clearTimeout(timer)
  }, [onDone])

  return (
    <div style={{
      position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999, overflow: 'hidden',
    }}>
      <style>{`
        @keyframes notefall {
          0%   { opacity: 0; transform: translateY(-20px) translateX(0) scale(0.5); }
          15%  { opacity: 1; transform: translateY(30px) translateX(var(--drift)) scale(1); }
          100% { opacity: 0; transform: translateY(45vh) translateX(var(--drift)) scale(0.6); }
        }
      `}</style>
      {notes.map((n) => (
        <span
          key={n.id}
          style={{
            position: 'absolute',
            top: 0,
            left: `${n.left}%`,
            fontSize: n.size,
            color: n.color,
            '--drift': `${n.drift}px`,
            animation: `notefall ${n.duration}ms ease-out ${n.delay}ms forwards`,
            opacity: 0,
          }}
        >
          {n.note}
        </span>
      ))}
    </div>
  )
}
